import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material"
import { ObrasTopHeader } from "../../components/obras_top_header"
import FormContainer from "../../../../../common/components/form_container"
import AlertError from "../../../../../common/components/alert_error"
import BottomBar from "../../../../../common/components/bottom_bar"
import PrimaryButton from "../../../../../common/components/primary_button"
import DynamicIcon from "../../../../../common/components/dynamic_icon"
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal"
import { Link as LinkTo } from 'react-router';
import { ObrasTopBar } from "../../components/obras_top_bar"
import { ObrasReportModals } from "../../components/obras_report_modals"
import { useEmpreendimentoUnidadeCadastroViewModel } from "../../viewModels/empreendimento_unidade_cadastro_view_model"
import { useMemo } from "react"
import { DefaultFormMultiAutocomplete } from "../../../../../common/components/default_form_multi_autocomplete"
import { DefaultFormNumericInput } from "../../../../../common/components/default_form_numeric_input"
import { FormMoneyMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_money_masked_input"
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid"
import { DefaultMultiAutocomplete } from "../../../../../common/components/default_multi_autocomplete"
import { ChecklistServicoEmpreendimento } from "../../../../incorporacao/domain/models/checklist_servico_empreendimento_lista"
import { GenerateChecklistServicoEmpreendimentoColumns } from "./columns/checklist_servico_multi"
import DeleteDialog from "../../../../../common/components/delete_dialog"

export const EmpreendimentoUnidadeCadastro = () => {
    const viewModel = useEmpreendimentoUnidadeCadastroViewModel();
    const columnsDefChecklist = useMemo(() => {
        return GenerateChecklistServicoEmpreendimentoColumns({
            OnActionValorChange: viewModel.handleValorChange,
            OnActionQuantidadeChange: viewModel.handleQuantidadeChange,
            onActionEditar: viewModel.handleEditar,
            onActionDelete: viewModel.handleDeleteOpenState,
        });
    }, [
        viewModel.handleEditar,
        viewModel.handleQuantidadeChange,
        viewModel.handleValorChange,
        viewModel.handleDeleteOpenState,
    ]);

    return (
        <>
            <ObrasTopBar
                obrasReportState={viewModel.obrasReportState}
                state={viewModel.obrasTopHeaderState}
                selectedObra={viewModel.selectedObraHeaderInfo}
                onBack={viewModel.handlePageBack}>
            </ObrasTopBar>

            <form className="pb-8" onSubmit={viewModel.handleCadastroItensEmpreendimentoSubmit}>
                <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                    <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                        <Link underline="hover" color="inherit">
                            Obras
                        </Link>
                        <Link underline="hover" color="inherit" component={'span'}>
                            <LinkTo to='/Obras_lista'>Lista de Obras</LinkTo>
                        </Link>
                        <Typography className="text-primary-green">
                            Empreendimento Incorporação Unidade
                        </Typography>
                    </Breadcrumbs>
                    <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                        <ObrasTopHeader
                            title='Empreendimento Incorporação Unidade'
                            selectedObra={viewModel.selectedObraHeaderInfo}
                            onReload={viewModel.handleReload}
                        />
                    </div>

                    {
                        "" === undefined ? (
                            <div className="w-full">
                                <AlertError
                                    messageErro={""}
                                    onTryAgain={() => { }} />
                            </div>
                        ) : (
                            <>
                            </>
                        )
                    }
                    <div className='w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4'>
                        {
                            viewModel.openCadastro &&
                            <FormContainer title={"Cadastrar/Editar"} arrangement="fullRow">
                                <div className="flex flex-col gap-y-4 w-full pt-2">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <DefaultFormMultiAutocomplete
                                            name='idsChecklistServico'
                                            label='Checklists de Serviço'
                                            required={true}
                                            options={viewModel.checklistServicosObraDropDown}
                                            getOptionKey={x => x.id}
                                            getOptionLabel={x => x.title}
                                            reactHookForm={viewModel.hookForm} />
                                    </div>

                                    <div className="flex flex-row justify-start gap-3">
                                        {
                                            viewModel.salvarPorBloco === 0 ? (
                                                <div className="w-[65%]">
                                                    <DefaultFormMultiAutocomplete
                                                        name='idsBloco'
                                                        label='Blocos'
                                                        required={false}
                                                        options={viewModel.listBlocoDropDown}
                                                        getOptionKey={x => x.id}
                                                        getOptionLabel={x => x.title}
                                                        reactHookForm={viewModel.hookForm} />
                                                </div>)
                                                :
                                                (
                                                    <div className="w-[65%]">
                                                        <DefaultFormMultiAutocomplete
                                                            name='idsUnidade'
                                                            label='Unidades'
                                                            options={viewModel.listUnidadeDropDown}
                                                            required={false}
                                                            getOptionKey={x => x.id}
                                                            getOptionLabel={x => x.title}
                                                            reactHookForm={viewModel.hookForm} />
                                                    </div>
                                                )
                                        }
                                    </div>

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <DefaultFormNumericInput
                                            name="quantidade"
                                            label="Quantidade Prevista"
                                            required={false}
                                            reactHookForm={viewModel.hookForm}
                                        />
                                        <FormMoneyMaskedInput
                                            name="valorUnitario"
                                            label="Valor Unitário (R$)"
                                            largeNumbers={true}
                                            required={false}
                                            reactHookForm={viewModel.hookForm}
                                        />
                                    </div>

                                    <div className="w-full justify-start flex gap-3">
                                        <div className="w-[150px] justify-end">
                                            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
                                                <div className="w-[180px]">
                                                    <PrimaryButton
                                                        buttonColor="yellow"
                                                        onClick={viewModel.handleClearForm}>
                                                        Limpar formulário
                                                    </PrimaryButton>
                                                </div>
                                            </div>
                                        </div>
                                        <PrimaryButton
                                            type="submit"
                                            buttonColor="primary-green"
                                        >

                                            Incluir Itens
                                        </PrimaryButton>
                                    </div>
                                </div>
                            </FormContainer>
                        }

                        <FormContainer title={"Pesquisa Itens"} arrangement="fullRow">
                            <div className="flex flex-row gap-4 w-full pt-2">
                                <div className="w-full">
                                    <DefaultMultiAutocomplete
                                        label='Checklist de Serviço'
                                        value={viewModel.checklistServicosDropDown.filter(x => viewModel.filters.idsChecklistServico.includes(x.id))}
                                        options={viewModel.checklistServicosDropDown}
                                        getOptionLabel={x => x.title}
                                        getOptionKey={x => x.id}
                                        onChange={x => viewModel.handleIdsChecklistServicoChange(x?.map(y => y.id) ?? [])} />
                                </div>

                                <div className="w-full">
                                    <DefaultMultiAutocomplete
                                        label='Blocos'
                                        value={viewModel.listBlocoDropDown.filter(x => viewModel.filters.idsBlocos.includes(x.id))}
                                        options={viewModel.listBlocoDropDown}
                                        getOptionLabel={x => x.title}
                                        getOptionKey={x => x.id}
                                        onChange={x => viewModel.handleIdsBlocoChange(x?.map(y => y.id) ?? [])} />
                                </div>

                                <div className="w-[150px] justify-end">
                                    <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 justify-end">
                                        <div className="w-[180px]">
                                            <PrimaryButton
                                                buttonColor="yellow"
                                                onClick={viewModel.handleClearFilters}>
                                                Limpar filtros
                                            </PrimaryButton>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </FormContainer>
                        <>
                            <Stack spacing={0}>
                                <div className="w-full flex flex-row justify-between items-stretch">
                                    <div className="flex flex-col justify-between flex-1">
                                        <TablePagination
                                            component="div"
                                            count={viewModel.pagination.totalItems}
                                            page={viewModel.pagination.page - 1}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                            rowsPerPage={viewModel.pagination.rowsPerPage}
                                            onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))} />
                                    </div>
                                </div>

                                <StyledDataGrid
                                    tableName="checklist_servico_empreendimento_lista"
                                    disableColumnMenu={false}
                                    showToolbar={true}
                                    disableRowSelectionOnClick={true}
                                    getRowId={(row: ChecklistServicoEmpreendimento) => row.idChecklistServicoEmpreendimento}
                                    columns={columnsDefChecklist}
                                    loading={viewModel.loading}
                                    checkboxSelection={false}
                                    rows={viewModel.listaChecklistServicoEmpreendimento}
                                    rowCount={viewModel.listaChecklistServicoEmpreendimento.length}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    paginationMode="server"
                                    paginationModel={{
                                        page: viewModel.pagination.page - 1,
                                        pageSize: viewModel.pagination.rowsPerPage,
                                    }}
                                    pinnedColumns={{
                                        right: ['idChecklistServicoEmpreendimento'],
                                    }}
                                    getRowHeight={() => 'auto'}
                                />
                                <TablePagination
                                    component="div"
                                    count={viewModel.pagination.totalItems}
                                    page={viewModel.pagination.page - 1}
                                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                    rowsPerPage={viewModel.pagination.rowsPerPage > 0 ? viewModel.pagination.rowsPerPage : 100}
                                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                                />

                            </Stack>
                        </>
                    </div>
                </div >

                <BottomBar>
                    <div className="relative w-full h-full items-center justify-end flex p-4">
                        {/* Centralizada na barra, independente da largura dos botões laterais. */}
                        {viewModel.possuiAlteracaoItens && (
                            <div className="absolute left-1/2 -translate-x-1/2 flex items-center gap-1 text-sm font-semibold text-red-500">
                                <DynamicIcon nameIcon="WarningAmberRounded" size={20} className="text-red-500" />
                                <span>Ao editar a quantidade ou o valor, clicar no botão salvar!</span>
                            </div>
                        )}

                        <div className="flex flex-row gap-4">
                            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                <h1
                                    className="text-sm text-black dark:text-white"
                                    onClick={viewModel.handlePageBack}>
                                    Cancelar
                                </h1>
                            </div>
                            <div className="w-[130px]">
                                {viewModel.saving && viewModel.listaChecklistServicoEmpreendimento.length > 0
                                    ? (
                                        <PrimaryButton>
                                            Salvando...
                                        </PrimaryButton>
                                    ) : (

                                        <PrimaryButton
                                            type="button"
                                            onClick={viewModel.handleUpdateItensEmpreendimentoByConsulta}
                                            startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}>
                                            Salvar
                                        </PrimaryButton>
                                    )}
                            </div>
                        </div>
                    </div>
                </BottomBar>
            </form >

            <DeleteDialog
                open={viewModel.openDeleteModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir estes itens?`}
                onDelete={viewModel.handleDeleteItensEmpreendimentoByConsulta} />

            < ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory} />

            <ObrasReportModals
                state={viewModel.obrasReportState} />
        </>
    )
}